module.exports = "https://cdn-web.ertelecom.ru/b2c-domru/frontend/_next/static/images/step8-177adb7795e2c8c54d8b306185a1d190.svg";